export default __webpack_public_path__ + "static/media/words.52ee3ff2.png";